import { AxiosPromise, AxiosRequestConfig } from 'axios';
import { instanceApi } from 'libs';
import * as Types from 'types';

export const login = (data: Types.LoginRequest): AxiosPromise<Types.LoginResponse> => {
  const request: AxiosRequestConfig = {
    url: '/login',
    method: 'POST',
    data,
  };
  return instanceApi(request);
};

export const verifyToken = (
  data: Types.LoginWithTokenRequest
): AxiosPromise<Types.LoginResponse> => {
  const request: AxiosRequestConfig = {
    url: '/verify_token',
    method: 'GET',
    headers: {
      Authorization: `Bearer ${data.token}`,
    },
    data: {},
  };
  return instanceApi(request);
};
